import React, { useState, useRef, useEffect, forwardRef } from 'react';
import { Col, Form, Input, Row, Select, InputNumber, Space, Button, Skeleton } from 'antd';
import {insert, update, getById, } from '../../../../apis/MovimientoDiasHorasApi';
import {getList as getPeriodos, getDetailsById as getDetailsByPeriodId} from '../../../../apis/PeriodosApi';
import {getList as getTipoSaldos} from '../../../../apis/TipoSaldoApi';
import {getEmpleados} from '../../../../apis/OdooApi';
import {status_period} from '@app/constants/period';
import _ from 'lodash';

const { Option } = Select;
const App = forwardRef(function AnioPeriodo({onOk, onCancel, form, object, values, disabledForm, period}, ref) {
    const [ID, setID] = useState(null);
    const [disabled, setDisabled] = useState(disabledForm ?? false);
    const [modified, setModified] = useState(false);
    const [initialValues, setInitialValues] = useState(values);
    const searchInput = useRef(null);
    const [tiposSaldo, setTiposSaldo] = useState([]);
    const [empleados, setEmpleados] = useState([]);
    const [tiposPeriodo, setTiposPeriodo] = useState([]);
    const [tipoPeriodoSelected, setTiposPeriodoSelected] = useState([]);
    const [detailsPeriodo, setDetailsPeriodo] = useState([]);
    const [periodObject, setPeriodObject] = useState(period);
    
    //1- Sustituir 2- Sumar 3- No Sustituir, Default 1
    const [tipoIncidencia, setTipoIncidencia] = useState([
        {value: '1',	text: 'Horas Ordinarias'},
        {value: '2',	text: 'Horas Retardo'},
        {value: '3',	text: 'Horas Adicionales'},
        {value: '4',	text: 'Horas Domingo'},
        {value: '5',	text: 'Horas Extras Dobles'},
        {value: '6',	text: 'Horas Extras Triples'},
        {value: '7',	text: 'Horas Festivo Trab.'},
        {value: '8',	text: 'Horas Descanso Trab.'},
        {value: '9',	text: 'Horas Vacaciones Trab.'},
        {value: '10', text: 'Horas Permiso c/Goce'},
        {value: '11', text: 'Horas Permiso s/Goce'},
        {value: '12', text: 'Días Falta Injustificada'},
        {value: '13', text: 'Días Vacaciones'},
        {value: '14', text: 'Días Aguinaldo'},
        {value: '15', text: 'Días Asistencia'},
        {value: '16', text: 'Días Retardo'},
        {value: '17', text: 'Días IMSS'},
        {value: '18', text: 'Días EyM'},
        {value: '19', text: 'Días Ajuste'},
        {value: '20', text: 'Horas Extras'},
        {value: '21', text: 'Días Ordinario'},
    ]);
    const conceptoRef = React.createRef();
    const effectRan = useRef(false);

    useEffect(() => {
        if(period){
            setPeriodObject(period);            
        }
    }, [period]);
        
    useEffect(() => {
        if (!effectRan.current) {
            (async () => {
                await getCatalogs();
                await getEmpleadosOdoo();
            })();
        }
        return () => effectRan.current = true;
    }, []);

    useEffect(() => {
        (async () => {
            if(object?.id > 0){
                setID(object.id);
                await refreshData(object.id);
            }
        })();
    }, [object]);

    useEffect(() => {
        (async () => {
            if(tipoPeriodoSelected?.value > 0){
                await getDetailsPeriodo(tipoPeriodoSelected.value);                    
            }
        })();
    }, [tipoPeriodoSelected]);

    useEffect(() => {
        (async () => {
            setDisabled(disabledForm)
        })();
    }, [disabledForm]);
    
    const refreshData = async (id)=> {
        const response = await getById(id);
        if(response.ok){
            let item = response.payload;
            setInitialValues(item);
            form.setFieldsValue(item);
        }
    }
    
    const getCatalogs = async ()=> {
        const responsePeriodos = await getPeriodos();
        if(responsePeriodos.ok){
          let items = responsePeriodos.payload;
          setTiposPeriodo(items);
        }
        const responseTipoSaldo = await getTipoSaldos();
        if(responseTipoSaldo.ok){
          let items = responseTipoSaldo.payload;
          setTiposSaldo(items);
        }
    }

    const getEmpleadosOdoo = async ()=>{
        const response = await getEmpleados();
        if(response.ok){
            let items = response.payload;
            setEmpleados(items);
        }
    }

    const getDetailsPeriodo = async (id)=>{
        let detailsResponse = await getDetailsByPeriodId(id);
        if(detailsResponse.ok){
            let item = detailsResponse.payload;
            setDetailsPeriodo(item);
        }
    }

    const onReset = () => {
        form.resetFields();
    };

    const onCancelBtn = async ()=>{
        if(onCancel){
            await onCancel();
        }
    }

    const onFinish = async ()=> {
        await onOk()
    }

    return (
        <>
            <Form disabled={disabled}
                layout="vertical" 
                form={form} 
                requiredMark 
                autoComplete="off"
                onFinish={onFinish}>
                <Row gutter={16}>
                    <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="odoo_empleado_id"
                            label="Empleado"
                            rules={[
                            {
                                required: true,
                                message: 'Selecciona un empleado',
                            },
                            ]}
                        >
                                <Select placeholder="Por favor selecciona un empleado">
                                {
                                    empleados.map((item)=><Option value={item.value}>{item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 8}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="tipo_incidencia"
                            label="Tipo de incidencia"
                            rules={[
                            {
                                required: true,
                                message: 'Selecciona un tipo de incidencia',
                            },
                            ]}
                        >
                                <Select placeholder="Por favor selecciona un tipo de incidencia">
                                {
                                    tipoIncidencia.map((item)=><Option value={item.value}>{"(" + item.value + ") " + item.text}</Option>)
                                }
                            </Select>
                        </Form.Item>
                    </Col>
                </Row>
                <Row gutter={16}>
                    <Col md={{span: 4}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="dias"
                            label="Días"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega los dias',
                            },
                            ]}>
                            <InputNumber placeholder="Por favor agrega los dias" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 4}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="horas"
                            label="Horas"
                            rules={[
                            {
                                required: true,
                                message: 'Por favor agrega las horas',
                            },
                            ]}>
                            <InputNumber placeholder="Por favor agrega las horas" style={{width: '80%',}}/>
                        </Form.Item>
                    </Col>
                    <Col md={{span: 6}} sm={{span: 12}} xs={{span: 24}}>
                        <Form.Item
                            name="referencia"
                            label="Referencia"
                        >
                            <Input placeholder="Por favor agrega una referencia" />
                        </Form.Item>
                    </Col>
                </Row>
                <Form.Item>
                    <Space>
                        {
                            ID &&
                            <Button type="default" onClick={onCancelBtn}>
                                Cancelar
                            </Button>
                        }
                        
                        <Button type="primary" htmlType="submit" disabled={!periodObject || (periodObject.status === status_period.cerrado || periodObject.status === status_period.timbrado_parcial) }>
                            Guardar
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Limpiar
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
        </>
    );
});

export default App;
